var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodFineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#DADCF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.9907C15.625 15.8689 16.5344 14.9595 17.6562 14.9595C18.7781 14.9595 19.6875 15.8689 19.6875 16.9907V21.0532C19.6875 22.1751 18.7781 23.0845 17.6562 23.0845C16.5344 23.0845 15.625 22.1751 15.625 21.0532V16.9907Z",
    fill: "#4C555F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6875 16.9907C32.6875 15.8689 33.5969 14.9595 34.7188 14.9595C35.8406 14.9595 36.75 15.8689 36.75 16.9907V21.0532C36.75 22.1751 35.8406 23.0845 34.7188 23.0845C33.5969 23.0845 32.6875 22.1751 32.6875 21.0532V16.9907Z",
    fill: "#4C555F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0532 35.0627C14.0532 33.9702 14.9389 33.0845 16.0315 33.0845H36.344C37.4365 33.0845 38.3222 33.9702 38.3222 35.0627C38.3222 36.1553 37.4365 37.041 36.344 37.041H16.0315C14.9389 37.041 14.0532 36.1553 14.0532 35.0627Z",
    fill: "#4C555F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodFineIcon);
export default __webpack_public_path__ + "static/media/MoodFineIcon.6b1d5e9c6f07e1e9cbfc3766828e0d66.svg";
export { ForwardRef as ReactComponent };